import script from "./SingleBet.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleBet.vue?vue&type=script&setup=true&lang=js"

import "./SingleBet.vue?vue&type=style&index=0&id=6f852ab2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f852ab2"]])

export default __exports__